import { type MouseEvent, memo } from 'react';

import { WorkspaceAgentGuidedVariantSizeGroupToggle } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSizeGroupToggle';
import { WorkspaceAgentGuidedVariantSizeOptionRow } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSizeOptionRow';
import {
  isWorkspaceAgentSmartResizeSizeSelected,
  type WorkspaceAgentSmartResizeChannelGroup,
  type WorkspaceAgentSmartResizeSize,
  workspaceAgentSmartResizeChannelToSize,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentSmartResize';

export type WorkspaceAgentGuidedVariantSmartResizeFlatChannelGroupProps = {
  group: WorkspaceAgentSmartResizeChannelGroup;
  isExpanded: boolean;
  onSelectSize: (event: MouseEvent<HTMLButtonElement>) => void;
  onToggle: (event: MouseEvent<HTMLButtonElement>) => void;
  sizes: readonly WorkspaceAgentSmartResizeSize[];
};

export const WorkspaceAgentGuidedVariantSmartResizeFlatChannelGroup = memo(
  ({
    group,
    isExpanded,
    onSelectSize,
    onToggle,
    sizes,
  }: WorkspaceAgentGuidedVariantSmartResizeFlatChannelGroupProps) => (
    <div>
      <WorkspaceAgentGuidedVariantSizeGroupToggle
        groupId={group.id}
        isExpanded={isExpanded}
        label={group.label}
        onToggle={onToggle}
      />
      {isExpanded ? (
        <div className="flex flex-col pl-6">
          {group.sizes.map((channel) => (
            <WorkspaceAgentGuidedVariantSizeOptionRow
              channel={channel}
              isSelected={isWorkspaceAgentSmartResizeSizeSelected(
                sizes,
                workspaceAgentSmartResizeChannelToSize(channel),
              )}
              key={channel.id}
              onClick={onSelectSize}
            />
          ))}
        </div>
      ) : null}
    </div>
  ),
);

WorkspaceAgentGuidedVariantSmartResizeFlatChannelGroup.displayName =
  'WorkspaceAgentGuidedVariantSmartResizeFlatChannelGroup';
